import { formatCurrency } from "../../modules/formatCurrency";
import { useTranslation } from "react-i18next";

export const AddOnServices = (props) => {
  const { t } = useTranslation();
  const { bookingSidebar, branding, currency, convertAmount } = props;
  const customParagraphStyle = {
    color: branding.paragraphColor,
    fontFamily: branding.paragraphFont,
  };
  return bookingSidebar
    .filter((item) => item.type === "addonservice") // Filter only addon services
    .map((item, index) => (
      <li className="bs list-group-item" key={index}>
        <p>
          <strong>{t("booking.add_on_service.service_name")}:</strong>
          <span style={customParagraphStyle}> {item.serviceName}</span>
        </p>
        <p>
          <strong>{t("booking.add_on_service.description")}:</strong>
          <span style={customParagraphStyle}> {item.serviceDescription}</span>
        </p>
        <p>
          <strong>{t("booking.add_on_service.service_price")}:</strong>
          <span style={customParagraphStyle}>
            {" "}
            {formatCurrency(item.servicePrice, currency, convertAmount)}{" "}
            {currency}
          </span>
        </p>
      </li>
    ));
};
